export const translations = {
  en: {
    // Home Screen
    askAi: 'Ask AI',
    startChat: 'Start Chat',
    poweredBy: 'Powered by',

    // Chat Header
    resetChat: 'Reset Chat',
    resetChatConfirm: 'Are you sure you want to reset the chat? This action cannot be undone.',
    cancel: 'Cancel',
    reset: 'Reset',

    // Form Fields
    optional: 'Optional',
    newsletterConfirmEmail:
      'If this address is new, we will send you a confirmation email. Your subscription starts once you confirm it.',
    uploading: 'Uploading...',
    select: 'Select...',
    selectOption: 'Select option',

    // Validation Messages
    validation: {
      required: 'This field is required',
      invalidEmail: 'Invalid email format',
      numericOnly: 'Only numbers allowed',
      fileTooLarge: 'File too large. Max 10MB allowed.',
      uploadError: 'Error occurred while uploading file.',
      submissionError: 'Something went wrong during submission.',
      submissionSuccess: 'Thank you for your submission!',
      duplicateFile: 'Duplicate files are not allowed!',
    },

    // Chat Messages
    postError: 'Error while posting post.',
    failedToSendMessage: 'Failed to send message',
    reactionFailed: 'Reaction failed',
    messageCopied: 'Message copied!',
    failedChatMessage: 'Failed to reset chat',
    chatResetSuccessfully: 'Chat has been reset successfully!',
    chatbotServiceUnavailable: 'Chatbot service is temporarily unavailable. Please try again later',
    failedToGetResponseFromChatbot: 'Failed to get response from chatbot',
    fallbackLeadMessage: 'Form submitted successfully!',
    errorOccurred: 'An error occurred',
    fallbackForm: {
      intro:
        'I couldn\'t find the answer you\'re looking for. Would you like to leave your contact information? We\'ll get back to you soon!',
      nameLabel: 'Name',
      namePlaceholder: 'Enter your name',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      messageLabel: 'Message',
      messagePlaceholder: 'How can we help?',
      submitLabel: 'Submit',
    },
  },
  fi: {
    // Home Screen
    askAi: 'Kysy AI:lle',
    startChat: 'Aloita keskustelu',
    poweredBy: 'Voimanlähteenä',

    // Chat Header
    resetChat: 'Nollaa keskustelu',
    resetChatConfirm: 'Haluatko varmasti nollata keskustelun? Tätä toimintoa ei voi perua.',
    cancel: 'Peruuta',
    reset: 'Nollaa',

    // Form Fields
    optional: 'Valinnainen',
    newsletterConfirmEmail: 'Jos osoite on uusi, lähetämme vahvistusviestin. Tilaus alkaa, kun vahvistat sen.',
    uploading: 'Ladataan...',
    select: 'Valitse...',
    selectOption: 'Valitse vaihtoehto',

    // Validation Messages
    validation: {
      required: 'Tämä kenttä on pakollinen',
      invalidEmail: 'Virheellinen sähköpostimuoto',
      numericOnly: 'Vain numerot sallittu',
      fileTooLarge: 'Tiedosto on liian suuri. Maksimi 10MB sallittu.',
      uploadError: 'Tiedoston latauksessa tapahtui virhe.',
      submissionError: 'Lähetyksessä tapahtui virhe.',
      submissionSuccess: 'Kiitos lähetyksestäsi!',
      duplicateFile: 'Kaksoiskappaleet eivät ole sallittuja!',
    },

    // Chat Messages
    postError: 'Virhe viestin lähettämisessä.',
    failedToSendMessage: 'Viestin lähetys epäonnistui',
    reactionFailed: 'Reaktio epäonnistui',
    messageCopied: 'Viesti kopioitu!',
    failedChatMessage: 'Keskustelun nollaus epäonnistui',
    chatResetSuccessfully: 'Keskustelu on nollattu onnistuneesti!',
    chatbotServiceUnavailable: 'Chatbot-palvelu on tilapäisesti poissa käytöstä. Yritä myöhemmin uudelleen',
    failedToGetResponseFromChatbot: 'Vastauksen saaminen chatbotilta epäonnistui',
    fallbackLeadMessage: 'Lomake lähetetty onnistuneesti!',
    errorOccurred: 'Tapahtui virhe',
    fallbackForm: {
      intro: 'En löytänyt etsimääsi vastausta. Haluaisitko jättää yhteystietosi? Palaamme asiaan pian!',
      nameLabel: 'Nimi',
      namePlaceholder: 'Kirjoita nimesi',
      emailLabel: 'Sähköposti',
      emailPlaceholder: 'Kirjoita sähköpostiosoitteesi',
      messageLabel: 'Viesti',
      messagePlaceholder: 'Miten voimme auttaa?',
      submitLabel: 'Lähetä',
    },
  },
  sv: {
    // Home Screen
    askAi: 'Fråga AI',
    startChat: 'Starta chatten',
    poweredBy: 'Drivs av',

    // Chat Header
    resetChat: 'Återställ chatten',
    resetChatConfirm: 'Är du säker på att du vill återställa chatten? Detta kan inte ångras.',
    cancel: 'Avbryt',
    reset: 'Återställ',

    // Form Fields
    optional: 'Valfritt',
    newsletterConfirmEmail:
      'Om adressen är ny skickar vi ett bekräftelsemejl. Prenumerationen börjar när du bekräftar den.',
    uploading: 'Laddar upp...',
    select: 'Välj...',
    selectOption: 'Välj alternativ',

    // Validation Messages
    validation: {
      required: 'Detta fält är obligatoriskt',
      invalidEmail: 'Ogiltigt e-postformat',
      numericOnly: 'Endast siffror tillåtna',
      fileTooLarge: 'Filen är för stor. Max 10MB tillåtet.',
      uploadError: 'Ett fel uppstod vid filuppladdning.',
      submissionError: 'Något gick fel vid inlämningen.',
      submissionSuccess: 'Tack för din inlämning!',
      duplicateFile: 'Dubbletter av filer är inte tillåtna!',
    },

    // Chat Messages
    postError: 'Fel vid publicering.',
    failedToSendMessage: 'Det gick inte att skicka meddelandet',
    reactionFailed: 'Reaktionen misslyckades',
    messageCopied: 'Meddelandet kopierat!',
    failedChatMessage: 'Det gick inte att återställa chatten',
    chatResetSuccessfully: 'Chatten har återställts!',
    chatbotServiceUnavailable: 'Chatbot-tjänsten är tillfälligt otillgänglig. Försök igen senare',
    failedToGetResponseFromChatbot: 'Det gick inte att få svar från chatboten',
    fallbackLeadMessage: 'Formuläret skickades in!',
    errorOccurred: 'Ett fel uppstod',
    fallbackForm: {
      intro:
        'Jag kunde inte hitta svaret du söker. Vill du lämna dina kontaktuppgifter? Vi återkommer snart!',
      nameLabel: 'Namn',
      namePlaceholder: 'Ange ditt namn',
      emailLabel: 'E-post',
      emailPlaceholder: 'Ange din e-post',
      messageLabel: 'Meddelande',
      messagePlaceholder: 'Hur kan vi hjälpa till?',
      submitLabel: 'Skicka',
    },
  },
  de: {
    // Home Screen
    askAi: 'KI fragen',
    startChat: 'Chat starten',
    poweredBy: 'Bereitgestellt von',

    // Chat Header
    resetChat: 'Chat zurücksetzen',
    resetChatConfirm:
      'Bist du sicher, dass du den Chat zurücksetzen möchtest? Dies kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    reset: 'Zurücksetzen',

    // Form Fields
    optional: 'Optional',
    newsletterConfirmEmail:
      'Wenn die Adresse neu ist, senden wir Ihnen eine Bestätigungs-E-Mail. Das Abonnement beginnt, sobald Sie es bestätigen.',
    uploading: 'Lädt hoch...',
    select: 'Auswählen...',
    selectOption: 'Option auswählen',

    // Validation Messages
    validation: {
      required: 'Dieses Feld ist erforderlich',
      invalidEmail: 'Ungültiges E-Mail-Format',
      numericOnly: 'Nur Zahlen erlaubt',
      fileTooLarge: 'Datei zu groß. Maximal 10MB erlaubt.',
      uploadError: 'Beim Hochladen der Datei ist ein Fehler aufgetreten.',
      submissionError: 'Beim Absenden ist etwas schiefgelaufen.',
      submissionSuccess: 'Vielen Dank für deine Einsendung!',
      duplicateFile: 'Doppelte Dateien sind nicht erlaubt!',
    },

    // Chat Messages
    postError: 'Fehler beim Posten.',
    failedToSendMessage: 'Nachricht konnte nicht gesendet werden',
    reactionFailed: 'Reaktion fehlgeschlagen',
    messageCopied: 'Nachricht kopiert!',
    failedChatMessage: 'Chat konnte nicht zurückgesetzt werden',
    chatResetSuccessfully: 'Chat wurde erfolgreich zurückgesetzt!',
    chatbotServiceUnavailable:
      'Chatbot-Dienst ist vorübergehend nicht verfügbar. Bitte versuche es später noch einmal',
    failedToGetResponseFromChatbot: 'Antwort vom Chatbot konnte nicht abgerufen werden',
    fallbackLeadMessage: 'Formular erfolgreich gesendet!',
    errorOccurred: 'Ein Fehler ist aufgetreten',
    fallbackForm: {
      intro:
        'Ich konnte die gesuchte Antwort nicht finden. Möchtest du deine Kontaktdaten hinterlassen? Wir melden uns bald!',
      nameLabel: 'Name',
      namePlaceholder: 'Gib deinen Namen ein',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'Gib deine E-Mail ein',
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Wie können wir helfen?',
      submitLabel: 'Absenden',
    },
  },
};

/**
 * Get translation for a given key and language
 * @param {string} key - Translation key (supports nested keys with dot notation, e.g., 'validation.required')
 * @param {string} lang - Language code ('en' or 'fi')
 * @returns {string} Translated text or the key if translation not found
 */
export const getTranslation = (key, lang = 'en') => {
  const langTranslations = translations[lang] || translations.en;

  // Support nested keys like 'validation.required'
  const keys = key.split('.');
  let value = langTranslations;

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      const enTranslations = translations.en;
      let enValue = enTranslations;
      for (const enK of keys) {
        if (enValue && typeof enValue === 'object' && enK in enValue) {
          enValue = enValue[enK];
        } else {
          return key;
        }
      }
      return enValue;
    }
  }

  return value || key;
};

// The admin persists whatever the optional-label key renders as in the operator's own UI language,
// so every translation of it is a platform default rather than customer-authored text.
const PLATFORM_OPTIONAL_LABELS = new Set(
  ['optional', ...Object.values(translations).map(({ optional }) => optional)].map(value => value.toLowerCase())
);

/**
 * Resolves the "(optional)" suffix: a customer-authored value wins, anything the platform seeded
 * falls through to the visitor's language. Idempotent, so it is safe to apply more than once.
 *
 * @param {string} storedLabel - optionalLabelText as stored on the field.
 * @param {string} lang - Active language code.
 * @returns {string} The suffix text to render.
 */
export const getOptionalLabel = (storedLabel, lang) => {
  const trimmed = storedLabel?.trim();

  return trimmed && !PLATFORM_OPTIONAL_LABELS.has(trimmed.toLowerCase()) ? trimmed : getTranslation('optional', lang);
};
